module.exports = __webpack_public_path__ + "static/img/logo17.ce6df4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link2/logo17.jpg
// module id = Ed4c
// module chunks = 1